export function reviewsSliderSolutions(){
    const slider = $(".reviews-slider-solutions");

    slider.slick({
        prevArrow: false,
        nextArrow: false,
        dots:true,
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/reviews-slider-solutions.js